import {
  KUSTOMER_APP_CHAT_MESSAGE_RECEIVE_EVENT,
  KUSTOMER_APP_CHAT_MESSAGE_SEND_EVENT,
  KUSTOMER_APP_CHAT_CSAT_SEND_EVENT,
  KUSTOMER_APP_CHAT_CSAT_SUBMIT_EVENT,
} from 'core_main/pubnub/constants';

import { createSatisfactionCallbackResponse } from 'core_main/api/satisfaction/helpers';
import { SatisfactionCallbackResponse } from 'core_main/api/satisfaction/types';
import { createMessageCallbackResponse } from '../send_message/helpers';
import { GetMessagesCallbackResponse, GetMessagesListMessage } from './types';
import { MessageCallbackResponse } from '../send_message/types';

export const createGetMessagesCallbackResponse = (
  pubnubMessages: GetMessagesListMessage[] | undefined,
  pages,
  sessionId,
): GetMessagesCallbackResponse => {
  let history = {
    satisfaction: {} as SatisfactionCallbackResponse,
    messages: [] as MessageCallbackResponse[],
  };

  if (pubnubMessages?.length) {
    history = pubnubMessages.reduce((acc, message) => {
      if (
        message.entry.name === KUSTOMER_APP_CHAT_MESSAGE_RECEIVE_EVENT ||
        message.entry.name === KUSTOMER_APP_CHAT_MESSAGE_SEND_EVENT
      ) {
        acc.messages.push(
          createMessageCallbackResponse(
            message.entry.data,
            message?.attachments?.data,
            message?.entry?.included,
          ),
        );
      }

      if (
        message.entry.name === KUSTOMER_APP_CHAT_CSAT_SEND_EVENT ||
        message.entry.eventType === KUSTOMER_APP_CHAT_CSAT_SUBMIT_EVENT
      ) {
        const form = message?.entry.included?.find(
          (entity) => entity.type === 'satisfaction',
        );

        const { timetoken } = message;

        acc.satisfaction = createSatisfactionCallbackResponse(
          message?.entry?.data,
          timetoken,
          form,
        );
      }

      return acc;
    }, history);
  }

  return {
    conversationId: sessionId,
    pages,
    ...history,
  };
};
